var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaCsvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minerva_csv_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.951,
    height: 90.026,
    viewBox: "0 0 78.951 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139320",
    "data-name": "\\uD328\\uC2A4 139320",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(12.218 4.231)",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139321",
    "data-name": "\\uD328\\uC2A4 139321",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(7.987 0)",
    fill: "#f1f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139322",
    "data-name": "\\uD328\\uC2A4 139322",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.914.914,0,0,1,.269.269.9.9,0,0,1,.91,0H27.077a.91.91,0,1,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(9.805 1.82)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139323",
    "data-name": "\\uD328\\uC2A4 139323",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(7.987 18.197)",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139324",
    "data-name": "\\uD328\\uC2A4 139324",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(7.987 20.4)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139325",
    "data-name": "\\uD328\\uC2A4 139325",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(51.362)",
    fill: "#d1d3d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139326",
    "data-name": "\\uD328\\uC2A4 139326",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(0 6.347)",
    fill: "#76a34f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139327",
    "data-name": "\\uD328\\uC2A4 139327",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(14.027 27.093)",
    fill: "#648940"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139328",
    "data-name": "\\uD328\\uC2A4 139328",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(33.099 27.093)",
    fill: "#648940"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139329",
    "data-name": "\\uD328\\uC2A4 139329",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(52.169 27.093)",
    fill: "#648940"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139330",
    "data-name": "\\uD328\\uC2A4 139330",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(14.027 40.677)",
    fill: "#648940"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139331",
    "data-name": "\\uD328\\uC2A4 139331",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(33.099 40.677)",
    fill: "#91b56b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139332",
    "data-name": "\\uD328\\uC2A4 139332",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(52.169 40.677)",
    fill: "#91b56b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139333",
    "data-name": "\\uD328\\uC2A4 139333",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(14.027 54.26)",
    fill: "#648940"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139334",
    "data-name": "\\uD328\\uC2A4 139334",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(33.099 54.26)",
    fill: "#91b56b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139335",
    "data-name": "\\uD328\\uC2A4 139335",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(52.169 54.26)",
    fill: "#91b56b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139336",
    "data-name": "\\uD328\\uC2A4 139336",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(14.027 67.844)",
    fill: "#648940"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139337",
    "data-name": "\\uD328\\uC2A4 139337",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(33.099 67.844)",
    fill: "#648940"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139338",
    "data-name": "\\uD328\\uC2A4 139338",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(52.169 67.844)",
    fill: "#648940"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139372",
    "data-name": "\\uD328\\uC2A4 139372",
    d: "M8.7,9.888a10.052,10.052,0,0,1-2.081.751,7.72,7.72,0,0,1-1.488.152A4.977,4.977,0,0,1,1.371,9.371,5.466,5.466,0,0,1,0,5.409,5.492,5.492,0,0,1,1.388,1.457,4.928,4.928,0,0,1,5.133,0,7.83,7.83,0,0,1,8.7.875V3H8.455A4.86,4.86,0,0,0,5.388,1.626,2.677,2.677,0,0,0,3.2,2.615a4.325,4.325,0,0,0-.806,2.8,4.193,4.193,0,0,0,.82,2.773A2.718,2.718,0,0,0,5.4,9.164a4.014,4.014,0,0,0,1.4-.252,5.874,5.874,0,0,0,1.674-1.12H8.7Zm1.14.076v-2.2h.234a6.13,6.13,0,0,0,1.774,1.006,5.528,5.528,0,0,0,1.926.372A3.025,3.025,0,0,0,15.314,8.8a1.064,1.064,0,0,0,.586-.958,1.031,1.031,0,0,0-.279-.758,2.267,2.267,0,0,0-1.058-.469q-.558-.1-1.905-.407A3.878,3.878,0,0,1,10.6,5.144,2.749,2.749,0,0,1,9.9,3.2,2.729,2.729,0,0,1,11.1.9,5.106,5.106,0,0,1,14.2.014a9.368,9.368,0,0,1,3.624.7v2.1H17.6a5.13,5.13,0,0,0-3.321-1.171,2.909,2.909,0,0,0-1.464.331,1.007,1.007,0,0,0-.575.9.987.987,0,0,0,.327.779,2.64,2.64,0,0,0,1.12.475q.792.145,1.767.382a5.227,5.227,0,0,1,1.454.534,3.063,3.063,0,0,1,.765.644,2.4,2.4,0,0,1,.427.775,2.994,2.994,0,0,1,.141.944,2.9,2.9,0,0,1-1.237,2.439,5.346,5.346,0,0,1-3.276.923A9.847,9.847,0,0,1,9.836,9.964ZM29.078.2,25.137,10.584H22.814L18.88.2h2.391L24.02,7.786,26.763.2Z",
    transform: "translate(8.487 8.991)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaCsvIcon);
export default __webpack_public_path__ + "static/media/minerva_csv_icon.b9845b24d3a8cfdabfb807a1ed8693e1.svg";
export { ForwardRef as ReactComponent };